import React from 'react';
import hat from '../../../images/mhat.png';
import './index.less';

export default () => (
  <div className="slide3 slide">
    <img className="slide3-hat" src={hat} alt="" />
  </div>
);
